module.exports = __webpack_public_path__ + "static/img/4.9466f52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/2/4.png
// module id = 3DGh
// module chunks = 0